import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { GoogleOAuthProvider } from '@react-oauth/google';

import "bootstrap/dist/css/bootstrap.min.css";
//import "bootstrap-social/bootstrap-social.css";
import "./index.css";
import "./components/assets/css/material-dashboard-react.css?v=1.9.0";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId="1091455767511-r42ffo1onsdj52u8hb0771dp3l5h2h5d.apps.googleusercontent.com">
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>
);
